import React from 'react';

import styles from './Link.scss';

const Link = () => (
  <div className={styles.linkContainer}>
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="33" fill="none" viewBox="0 0 38 33">
      <path
        fill="#fff"
        d="M38 15.4L23.222 0v8.8C8.444 11 2.112 22 0 33c5.278-7.7 12.667-11.22 23.222-11.22v9.02L38 15.4z"
      ></path>
    </svg>
    <p className={styles.linkText}>Copy the direct link</p>
  </div>
);

export default Link;
